<template>
    <header>
        <div class="row">
        <div class="col">
            <div id="toggle_menu" @click="toggleMenu">
            <i class="fa-solid fa-bars"></i>
        </div>
    </div>

        <div class="col logo">
            <router-link :to="{ name: 'home'}">
                <img src="@/assets/images/logo.png" />
            </router-link>
        </div>

        <div class="col">
        </div>
    </div>
    </header>
    <nav id="left_menu" :class="{ 'opened': menuStore.opened }">
        <ul>
        <div class="logo">
            <router-link :to="{ name: 'home'}">
                <img src="@/assets/images/logo.png" />
            </router-link>
        </div>

            <li :class="{ active: isActiveRoute('home') }">
                <router-link @click="closeMenu()" :to="{ name: 'home' }">
                    <i class="fa-regular fa-house icon"></i>
                    <span>Home</span>
                </router-link>
            </li>
            <li :class="{ active: isActiveRoute('messages') }">
                <router-link @click="closeMenu()" :to="{ name: 'messages'}">
                    <i class="fa-regular fa-paper-plane icon"></i>
                    <span>Correio interno</span>
                    <span v-if="notifications.messages" class="badge">{{ notifications.messages }}</span>
                </router-link>
            </li>
          <li v-if="user.profile_type == 'redator'" :class="{ active: isActiveRoute('articles') }">
            <router-link @click="closeMenu()" :to="{ name: 'articles' }">
              <i class="fa-regular fa-typewriter icon"></i>
              <span>Redação</span>
            </router-link>
          </li>
            <li v-if="['redator', 'publisher'].includes(user.profile_type)" class="submenu">
                <a>
                    <i class="fa-regular fa-newspaper icon"></i>
                    <span>Notícias</span>
                    <i class="fa-solid fa-chevron-down right_icon"></i>

                    <ul>
                        <li :class="{ active: isActiveRoute('articlesShare') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesShare' }">
                                <span>Gerais</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('articlesShareNovelas') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesShareNovelas', query: { category: 'NOVELAS' } }">
                                <span>Novelas</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('articlesShareEsportes') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesShareEsportes', query: { category: 'ESPORTES' } }">
                                <span>Esportes</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('articlesShareAFazenda') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesShareAFazenda', query: { category: 'A FAZENDA 18' } }">
                                <span>A Fazenda</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('articlesTopLinks') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesTopLinks' }">
                                <span>Top links</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('articlesLinks') }">
                            <router-link @click="closeMenu()" :to="{ name: 'articlesLinks' }">
                                <span>Links gerados</span>
                            </router-link>
                        </li>
                    </ul>
                </a>
            </li>
            <li v-if="['redator', 'publisher'].includes(user.profile_type)" :class="{ active: isActiveRoute('articlesRequests') }">
                <router-link @click="closeMenu()" :to="{ name: 'articlesRequests' }">
                <i class="fa-regular fa-flag icon"></i>
                    <span>Notícias solicitadas</span>
                  <span v-if="notifications.articles_requests" class="badge">{{ notifications.articles_requests }}</span>
                </router-link>
            </li>
            <li v-if="['redator', 'publisher'].includes(user.profile_type)" :class="{ active: isActiveRoute('socialPages') }">
                <router-link @click="closeMenu()" :to="{ name: 'socialPages' }">
                    <i class="fa-regular fa-share-nodes icon"></i>
                    <span>Redes sociais</span>
                </router-link>
            </li>
            <li v-if="['redator', 'ex-redator', 'publisher'].includes(user.profile_type)" class="submenu">
                <a>
                    <i class="fa-regular fa-chart-simple icon"></i>
                    <span>Relatórios</span>
                    <ul>
                        <li :class="{ active: isActiveRoute('reportArticles') }">
                            <router-link @click="closeMenu()" :to="{ name: 'reportArticles' }">
                                <span>Relatório de notícias</span>
                            </router-link>
                        </li>
                        <li :class="{ active: isActiveRoute('reportPages') }">
                            <router-link @click="closeMenu()" :to="{ name: 'reportPages' }">
                                <span>Relatório de páginas</span>
                            </router-link>
                        </li>
                    </ul>
                </a>
            </li>
            <li v-if="['redator', 'ex-redator', 'publisher'].includes(user.profile_type)" :class="{ active: isActiveRoute('payments') }">
                <router-link @click="closeMenu()" :to="{ name: 'payments' }">
                    <i class="fa-regular fa-wallet icon"></i>
                    <span>Financeiro</span>
                </router-link>
            </li>
            <li v-if="['redator', 'publisher'].includes(user.profile_type)" :class="{ active: isActiveRoute('faqs') }">
                <router-link @click="closeMenu()" :to="{ name: 'faqs' }">
                    <i class="fa-regular fa-life-ring icon"></i>
                    <span>Dúvidas frequentes</span>
                </router-link>
            </li>
            <li :class="{ active: isActiveRoute('supports') }">
                <router-link @click="closeMenu()" :to="{ name: 'supports' }">
                    <i class="fa-regular fa-messages icon"></i>
                    <span>Suporte</span>
                    <span v-if="notifications.supports" class="badge">{{ notifications.supports }}</span>
                </router-link>
            </li>

            <li :class="{ active: isActiveRoute('preAuthorizations') }">
                <router-link @click="closeMenu()" :to="{ name: 'preAuthorizations' }">
                    <i class="fa-regular fa-shield-check icon"></i>
                    <span>Pré-autorizações</span>
                    <span v-if="notifications.preAuthorizations" class="badge">{{ notifications.preAuthorizations }}</span>
                </router-link>
            </li>

            <li :class="{ active: isActiveRoute('suggestions') }">
                <router-link @click="closeMenu()" :to="{ name: 'suggestions' }">
                    <i class="fa-regular fa-lightbulb-on icon"></i>
                    <span>Sugestões</span>
                </router-link>
            </li>

            <li :class="{ active: isActiveRoute('account') }">
                <router-link @click="closeMenu()" :to="{ name: 'account' }">
                    <i class="fa-regular fa-user icon"></i>
                    <span>Minha conta</span>
                </router-link>
            </li>
        </ul>
        <div id="user_letter">{{ user.firstname.slice(0,1) }}</div>
        <div id="user_info">
            <div class="d-flex justify-content-between">
                <div v-if="user">
                    <span class="name">{{ user.firstname }}</span>
                    <span class="email">{{ user.email }}</span>
                </div>
                <button @click="logoutUser"><i class="fa-solid fa-arrow-right-from-bracket icon"></i></button>
            </div>
        </div>
    </nav>
</template>

<script setup>
    import { useAuthStore } from '@/stores/AuthStore';
    import { useMenuStore } from '@/stores/MenuStore';
    import { storeToRefs } from 'pinia';
    import { useRoute, useRouter } from 'vue-router';

    const route = useRoute();
    const router = useRouter();

    const isActiveRoute = (routeName) => {
        if (routeName === 'preAuthorizations') {
            return ['preAuthorizations', 'preAuthorizationCreate', 'preAuthorization'].includes(route.name);
        }
        return route.name === routeName;
    };

    const authStore = useAuthStore();
    const { user, notifications } = storeToRefs(authStore);

    const menuStore = useMenuStore();

    function logoutUser(){
        authStore.logout();
        router.push({ name: 'login'});
    }

    function toggleMenu(){
        if(menuStore.opened == true){
            menuStore.close();
        }else {
            menuStore.open();
        }
    }

    function closeMenu(){
        const leftMenu = document.getElementById('left_menu');
        const menuOpened = document.getElementsByClassName('menu_opened');
        
        if(menuOpened.length == 0){
            leftMenu.classList.add('no_hover');
        }
        
        leftMenu.onmouseleave = function() {
            leftMenu.classList.remove('no_hover');
        };
    }
</script>


<style>
    nav {
        background-color: #1e202a;
        max-width: 80px;
        width: 100%;
        height: 100%;
        top: 0;
        position: fixed;
        z-index: 99999;
        padding-bottom: 80px;
        overflow: hidden;
        white-space: nowrap;
        transition: 0s ease-in-out;
    }

    .menu_opened nav {
        max-width: 265px;
    }

    nav span {
        opacity: 0;
    }

    nav:hover {
        max-width: 265px;
    }

    nav:hover .logo {
        width: auto;
        margin-left: 0;
    }

    .menu_opened nav .logo {
        width: auto;
        margin-left: inherit;
    }

    .menu_opened #user_letter {
        display: none;
    }

    nav:hover span {
        opacity: 0.9;
    }

    .menu_opened nav span {
        opacity: 1;
    }

    nav:hover #user_info {
        opacity: 0.9;
        width: 265px;
    }

    nav:hover .right_icon {
        display: block;
    }

    .menu_opened #user_info {
        opacity: 1;
        width: 265px;
    }

    nav.no_hover:hover {
        max-width: 80px !important;
        cursor: default;
    }

    nav.no_hover:hover span,
    nav.no_hover:hover #user_info {
        opacity: 0 !important;
        width: auto !important;
    }


    nav.no_hover:hover .logo {
        width: 70px;
        margin-left: -10px;
    }

    .logo {
        text-align: left;
        padding: 20px 30px;
        width: 70px;
        overflow: hidden;
        margin-left: -10px;
        transition: 0.1s ease-in-out;
    }

    .logo img {
        width: 140px;
    }

    nav ul {
        padding: 0px;
        text-align: left;
        overflow-y: auto;
        overflow-x: hidden;
        width: 100%;
        height: 100%;
    }

    nav ul::-webkit-scrollbar {
        background: transparent;
        scrollbar-width: thin;
    }

    nav ul:hover::-webkit-scrollbar-thumb {
        background-color: #535871;
    }

    nav ul:hover {
        scrollbar-width: thin;
        scrollbar-color: #535871 transparent;
    }

    nav ul li a {
        padding: 15px 20px 15px 25px;
        border-left: 3px #1e202a solid;
        font-weight: 500;
        cursor: pointer;
        display: block;
        text-decoration: none;
        color: #cbcfe9 !important;
    }

    nav ul li .icon {
        margin-right: 15px;
        width: 20px;
        font-size: 18px;
        vertical-align: middle;
    }

    nav ul li .right_icon {
        float: right;
        margin-top: 2px;
        margin-right: 10px;
        font-size: 12px;
        display: none;
    }

    nav ul li a:hover {
        background-color: #2e313f;
        border-left: 3px #00bfcf solid;
        color: #00bfcf !important;
    }

    .dark nav ul li a:hover {
        background-color: #1a1c24;
        border-left: 3px #00bfcf solid;
        color: #00bfcf !important;
    }
    
    nav ul li.active a {
        border-left: 3px #00bfcf solid;
        color: #00bfcf !important;
    }

    nav ul li ul li.active a {
        border-left: 0;
        color: #00bfcf !important;
    }

    nav ul li ul {
        margin-top: 10px;
    }
    
    nav ul li ul li {
        list-style: none;
    }

    nav ul li ul li a {
        padding-left: 7px;
        border-left: 0;
    }

    nav ul li ul li a:hover {
        border-left: 0;
    }

    nav ul li ul li a:before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 4px;
        background-color: #a1bedb;
        border-radius: 8px;
        margin-right: 16px;
    }

    nav ul li ul li.active a:before,
    nav ul li ul li:hover a:before {
        background-color: #00bfcf;
    }

    nav ul li.submenu a:hover {
        background-color: inherit;
        border-left: 3px #1e202a solid !important;
    }

    nav ul li.submenu ul li a:hover {
        border-left: 0 !important;
    }

    #user_info {
        background-color: #262936;
        position: fixed;
        bottom: 0;
        left: 0;
        color: #a1bedb;
        padding: 20px 20px;
        border-top: 1px #36394a solid;
        width: 80px;
        box-sizing: border-box;
        line-height: 20px;
        opacity: 0;
        overflow: hidden;
    }

    .dark #user_info {
        background-color: #111216;
    }

    #user_info span {
        display: block;
        text-overflow: ellipsis;
        max-width: 178px;
        overflow: hidden;
    }

    #user_info span.name {
        font-size: 16px;
        font-weight: 600;
    }

    #user_info span.email {
        font-size: 13px;
    }

    #user_info button {
        background-color: #3b3e51;
        border: 0;
        border-radius: 4px;
        padding: 8px 12px;
        color: #a1bedb;
        margin-left: 15px;
        font-size: 12px;
    }

    #user_info button:hover {
        background-color: #444860;
    }

    nav ul li .badge {
        background-color: #00bfcf;
        border-radius: 25px;
        float: right;
    }

    header {
        background-color: #1b2127;
        padding: 0px;
        display: none;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
    }

    #toggle_menu {
        color: #9399b5;
        font-size: 16px;
        padding: 20px 25px;
        display: inline-block;
        cursor: pointer;
    }

    #toggle_menu:hover {
        color: #00bfcf;
    }

    header .logo {
        padding: 18px;
        text-align: center;
        width: 100%;
    }

    header .logo img {
        width: 100px;
    }

    #user_letter {
        background-color: #2c2f41;
        color: #818599;
        padding: 10px;
        text-align: center;
        font-size: 15px;
        font-weight: 700;
        border-radius: 25px;
        max-width: 40px;
        height: 40px;
        margin: 0 auto;
    }

    @media screen and (max-width: 1025px) {
        header {
            display: block;
        }
        
        nav {
            max-width: 100%;
            margin-top: 60px;
            padding-top: 20px;
            padding-bottom: 142px;
            display: none;
        }

        nav.opened {
            display: block;
        }

        nav .logo {
            display: none;
        }

        #user_info {
            width: 100% !important;
            opacity: 1;
        }

        nav {
            max-width: 100% !important;
        }

        nav span {
            opacity: 1;
        }


        nav.opened ul li .right_icon {
            display: block;
        }
    }
</style>